//Include Both Helper File with needed methods

import {
  
  getInvestmentSummery,
   getTotalReturns,
    
} from "../../../helpers/fakebackend_helper";



import { createAsyncThunk } from "@reduxjs/toolkit";


export const home_investment_summeryThunk = createAsyncThunk("home_investment_summeryThunk", async ({ params, token }, { rejectWithValue } ) => {
  try {
    const response = await getInvestmentSummery( params,token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










